import { ColDef } from 'ag-grid-community';

export const DispoColumnDef: ColDef[] = [
  {
    // Selectable
    headerName: 'Selectable',
    field: 'selectable',
    resizable: true,
    width: 90,
    tooltipField: 'selectable',
    filter: 'agTextColumnFilter',
    hide: true,
  },
  {
    // State
    headerName: 'State',
    field: 'state_abbreviation',
    resizable: true,
    width: 90,
    tooltipField: 'state',
    filter: 'agTextColumnFilter',
    cellStyle: getStateAbbreviationCellStyle,
  },
  {
    // Firearm ID
    headerName: 'Firearm ID',
    field: 'firearm_id',
    resizable: true,
    width: 125,
    tooltipField: 'firearm_id',
    filter: 'agTextColumnFilter',
  },
  {
    // Firearm
    headerName: 'Firearm',
    field: 'firearm',
    resizable: true,
    flex: 1,
    tooltipField: 'firearm',
    filter: 'agTextColumnFilter',
  },
  {
    // Serial #
    headerName: 'Serial #',
    field: 'serial_number',
    resizable: true,
    width: 125,
    tooltipField: 'serial_number',
    filter: 'agTextColumnFilter',
  },
  {
    // Received From
    headerName: 'Received From',
    field: 'received_from',
    resizable: true,
    width: 250,
    tooltipField: 'received_from',
    filter: 'agTextColumnFilter',
  },
  {
    // Date Received
    headerName: 'Date Acquired',
    field: 'date_acquired',
    resizable: true,
    width: 130,
    tooltipField: 'date_acquired',
    filter: 'agTextColumnFilter',
  }
];


export function getStateAbbreviationCellStyle(params: any): any {
  if (params.data.state === 'Available') {
    return { color: 'darkseagreen' }; // Change the color to red when the state is 'Available'
  } else if (params.data.state === 'Disposed') {
    return { color: 'coral' }; // Change the color to red when the state is 'Destroy'
  } else if (params.data.state === 'destroy') {
    return { color: 'lightsalmon' }; // Change the color to red when the state is 'Destroy'
  } else if (params.data.state === 'In Progress') {
    return { color: 'lightyellow' }; // Change the color to red when the state is 'In Progress'
  } else if (params.data.state === 'Lost Stolen') {
    return { color: 'red' }; // Change the color to red when the state is 'Lost Stolen'
  } else if (params.data.state === 'Reserved') {
    return { color: 'orange' }; // Change the color to red when the state is 'Reserved'
  } else if (params.data.state === 'Store Use') {
    return { color: 'purple' }; // Change the color to red when the state is 'Store Use'
  }
  return null; // Return null for default styling
}
// cellRendererFunctions.ts
export function checkboxRenderer(params: any): string {
  if (params.data.selectable === true) {
    const isChecked = params.data.select_item === true ? 'checked' : '';
    return `<div style="display: flex; justify-content: center; align-items: center; height: 100%;">
              <input type="checkbox" ${isChecked} />
            </div>`;
  }
  return '<div style="display: flex; justify-content: center; align-items: center; height: 100%;"></div>'; // Return an empty div to maintain cell height
}